$(document).ready(function () {
   'use strict';

   var $container = $('.js-volunteers-form');

   if ($container.length) {
       var $selects = $container.find('.js-select2:not(.js-additional-language-select2)');

       $selects.each(function () {
           var $target = $(this);

           $target.select2({
               'dropdownParent': $target.closest('.form-group-input'),
               'placeholder': "Выберите / Select",
           });
       });
   }
});
